<template>
  <v-card color="#bcdaff">
    <v-card-subtitle>
      <v-row>
        <div class="ml-4">
          <a href="/records"> Root</a>
        </div>
        <div v-if="filing" class="ml-2">
          <span class="mr-1"> > </span>
          <a :href="'/records/filings/' + filing.id "> {{ (filing) ? filing.title: 'Root' }}</a>
        </div>
        <div v-if="category" class="ml-2">
          <span class="mr-1"> > </span>
          <a :href="'/records/categories/' + category.id "> {{ category.title }}</a>
        </div>
        <div v-if="folder" class="ml-2">
          <span class="mr-1"> > </span>
          <a :href="'/records/folders/' + folder.id "> {{ folder.title }}</a>
        </div>
      </v-row>
    </v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  name: "RecordNavigation",
  props: {
    filing: Object,
    category: Object,
    folder: Object,
    file: String,
  },
  data() {
    return {
      root: "/records",
    };
  },
};
</script>

<style scoped>
  a {
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
</style>